import { IonContent, IonHeader, IonPage, IonToolbar, IonGrid } from "@ionic/react";
import React from "react";
import "./CreateUser.scss";
import UserForm from "../../../components/User/UserForm";
import NavigationMenu from "../../../components/Header/NavigationMenu/NavigationMenu";
import TitleOptionSearch from "../../../components/Header/TitleOptionSearch/TitleOptionSearch";

const CreateUser: React.FC = () => {
  document.title = `Créer un utilisateur - Canreport`

  return (
    <IonPage className="ion-page" id="main-content">
      <IonHeader className="center-content">
        <IonToolbar>
          <NavigationMenu
            active="utilisateurs"
            backLabel="Utilisateurs"
            backLink="/utilisateurs"
          />
          <TitleOptionSearch
            title="Créer un utilisateur"
          />
        </IonToolbar>
      </IonHeader>
      <IonContent className="IonPadding">
        <IonGrid className="center-content">
          <UserForm />
        </IonGrid>
      </IonContent>
    </IonPage>
  );
};

export default CreateUser;
